import {
  Button,
  Card,
  Controller,
  EyeIcon,
  EyeSlashIcon,
  Header,
  Input,
  permissionsLabels,
  permissionsMappingObject,
  permissionsTypes,
  Select,
  success,
  useCustomForm,
  useEffect,
  useState,
} from "@";
import PermissionsGrid from "./components/PermissionsGrid";
import { saveUser } from "./utils/api";
import { createDefaultValues, createSchema } from "./utils/validation";

const Create = () => {
  const [showPassword, setShowPassword] = useState(false);

  // Breadcrumb links
  const links = [
    { name: "الاعدادات", link: "/all-settings" },
    { name: "موظفي المتجر", link: "/settings-users" },
    { name: "اضافة", link: "" },
  ];

  // Define permissions mapping based on type
  const permissionsMapping = {
    0: Object.keys(permissionsLabels),
    ...permissionsMappingObject,
  };

  const {
    watch,
    errors,
    control,
    register,
    setValue,
    handleSubmit,
    isSubmitting,
  } = useCustomForm(createDefaultValues, createSchema);

  // Form submit handler
  const submit = async (data) => {
    try {
      await saveUser(data);
      await success("تم الاضافة بنجاح");
      window.location.reload();
    } catch (error) {}
  };

  // Get the selected user type
  const type = watch("type");

  // Update permissions based on selected type
  useEffect(() => {
    const selectedPermissions = permissionsMapping[type] || [];
    Object.keys(permissionsLabels).forEach((key) => {
      setValue(`permissions.${key}`, selectedPermissions.includes(key));
      setValue(
        `permissions.${key}_disabled`,
        selectedPermissions.includes(key),
      );
    });
  }, [type, setValue]);

  return (
    <>
      {/* Display header with links */}
      <Header title="اضافة موظف" links={links} />

      {/* User form */}
      <form onSubmit={handleSubmit(submit)}>
        {/* User data card */}
        <Card title="بيانات الموظف" className="mb-5">
          <div className="grid gap-5 md:grid-cols-4">
            <Input label="الاسم" error={errors.name} input={register("name")} />
            <Input
              label="رقم الهاتف"
              error={errors.phoneNumber}
              input={register("phoneNumber")}
            />
            <Input
              error={errors.email}
              label="البريد الالكتروني"
              input={register("email")}
            />

            <div className="relative">
              <Input
                dir="ltr"
                label="كلمة المرور"
                error={errors.password}
                styles="text-start input"
                autocomplete="new-password"
                input={register("password")}
                type={showPassword ? "text" : "password"}
              />

              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="icon-style absolute end-0 top-8 rounded-2xl rounded-s-none"
              >
                {showPassword ? (
                  <EyeSlashIcon className="h-6 w-6" />
                ) : (
                  <EyeIcon className="h-6 w-6" />
                )}
              </button>
            </div>
          </div>
        </Card>

        {/* Permissions card */}
        <div className="mb-5 mt-10">
          <h3 className="mb-3 text-lg font-semibold dark:text-gray-400">الصلاحيات</h3>
          <div className="mb-5 flex flex-col items-center gap-5 sm:flex-row">
            <Controller
              name="type"
              defaultValue={6}
              control={control}
              render={({ field }) => {
                const typeOptions = permissionsTypes.map((o) => ({
                  value: o.value,
                  label: o.name,
                }));
                return (
                  <div className="w-full sm:w-64">
                    <Select
                      inputId="type"
                      name={field.name}
                      options={typeOptions}
                      value={
                        typeOptions.find(
                          (o) => String(o.value) === String(field.value),
                        ) ?? null
                      }
                      onChange={(opt) => field.onChange(opt?.value ?? "")}
                      onBlur={field.onBlur}
                    />
                  </div>
                );
              }}
            />
          </div>

          <PermissionsGrid
            control={control}
            watch={watch}
            setValue={setValue}
            disabled={type != 6}
          />
        </div>

        <div className="floating-btn">
        <Button isLoading={isSubmitting} type="submit" title="حفظ البيانات" />
        </div>
      </form>
    </>
  );
};

export default Create;
